import { reduxMultiple } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxMultiple.HR.HOLIDAY()
export { reducer, actions, saga }
